import { BackdropImage } from '@/components/ui/backdropImage';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';
import { LockIcon } from '@/assets';
import { Button } from '@/components/ui/button';
import { routes } from '@/types/routes';

export const Route = createFileRoute('/_auth/(first-login)/password-set')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('passwordSet.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          <Trans i18nKey="passwordSet.description" ns="auth" />
        </CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col items-center">
        <BackdropImage src={ LockIcon } className="my-space-md" />
        <Link to={ routes.setupMfa } className="w-full">
          <Button className="w-full mt-space-lg">
            { t('buttons.continueTo2FA', { ns: 'auth' }) }
          </Button>
        </Link>
      </CardContent>
    </>
  );
}
